import { IShippingAddress, ShippingAddress } from '@lib/address';
import { DemandPrice, IDemandPrice } from './DemandPrice';

/**
 * How the shipping address on the demand header got there: derived by the system (personal default or the
 * address of the position sites) or chosen by the user. Mirrors the backend enum.
 */
export enum DemandShippingAddressOrigin {
    SYSTEM = 'SYSTEM',
    USER = 'USER',
}

export interface IDemandShippingAddressState {
    shippingAddress?: IShippingAddress;
    shippingAddressOrigin: DemandShippingAddressOrigin;
    shippingAddressReplaced: boolean;
}

export interface IDemandItemRemoved {
    price: IDemandPrice[];
    shippingAddress: IDemandShippingAddressState;
}

/**
 * The demand's shipping address after a write that may have changed it. The server derives the address from
 * the position sites, so every site-changing call reports it back instead of the client guessing.
 */
export class DemandShippingAddressChange {
    public readonly shippingAddress?: ShippingAddress;
    public readonly origin: DemandShippingAddressOrigin;
    /** True only on the response of the write that replaced an address that had dropped out of the list. */
    public readonly replaced: boolean;

    constructor(dto: IDemandShippingAddressState) {
        this.shippingAddress = dto.shippingAddress ? ShippingAddress.from(dto.shippingAddress) : undefined;
        this.origin = dto.shippingAddressOrigin;
        this.replaced = dto.shippingAddressReplaced;
    }
}

/** Answer to removing a demand position: the recalculated prices and the shipping address after it. */
export class DemandItemRemoved {
    public readonly price: DemandPrice[];
    public readonly shippingAddress: DemandShippingAddressChange;

    constructor(dto: IDemandItemRemoved) {
        this.price = dto.price.map((price) => DemandPrice.fromDto(price));
        this.shippingAddress = new DemandShippingAddressChange(dto.shippingAddress);
    }
}
